.timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--sp-4) var(--sp-3) var(--sp-6);
}

.insertLine {
  height: 0;
  margin: 0 var(--sp-2);
  border-radius: 1px;
  background: transparent;
  transition:
    height var(--dnd-dur) var(--dnd-ease),
    background-color var(--dnd-dur) var(--dnd-ease);
}

.insertLine.insertLineActive {
  height: 2px;
  background: var(--focus);
}

@media (prefers-reduced-motion: reduce) {
  .insertLine {
    transition: none;
  }
}

.copyLabel {
  position: sticky;
  top: 0;
  z-index: 2;
  align-self: flex-start;
  margin: 0 var(--sp-3) var(--sp-3);
  padding: var(--sp-1) var(--sp-4);
  background: var(--surface);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  border: var(--bw) solid var(--focus);
  border-radius: var(--radius);
  color: var(--focus);
  font-size: var(--fs-xs);
  font-weight: 600;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  flex: 1 1 auto;
  padding: var(--sp-8) var(--sp-5);
  text-align: center;
  color: var(--text-2);
}

.emptyTitle {
  font-size: var(--fs-md);
  font-weight: 600;
}

.emptyHint {
  max-width: 220px;
  font-size: var(--fs-sm);
  color: var(--text-3);
}
